/**
 * Global auth wiring for fetch().
 *
 * Rather than editing every `fetch(...)` call across the app (there
 * are 25+ of them), this patches window.fetch once, at app startup,
 * to:
 *   1. Attach `Authorization: Bearer <token>` to every request that
 *      targets our own API (REACT_APP_API_URL) - unless a request
 *      already sets its own Authorization header, e.g. login itself.
 *   2. On a 401 response, clear the stored session and redirect to
 *      the login page - so an expired/invalid token boots the user
 *      back to `/` instead of the app silently failing.
 *
 * Import this once, before anything else renders (see src/index.js).
 */

import { clearAuthStorage } from "./auth";

const API_URL = process.env.REACT_APP_API_URL || "";

const originalFetch = window.fetch.bind(window);

function getToken() {

    return localStorage.getItem("token");

}

function isOwnApiRequest(input) {

    if (!API_URL) {
        return false;
    }

    const url = typeof input === "string" ? input : (input && input.url) || "";

    return url.startsWith(API_URL);

}

window.fetch = async function patchedFetch(input, init = {}) {

    let finalInit = init;

    if (isOwnApiRequest(input)) {

        const token = getToken();

        const existingHeaders = init.headers instanceof Headers
            ? Object.fromEntries(init.headers.entries())
            : (init.headers || {});

        if (token && !existingHeaders.Authorization && !existingHeaders.authorization) {

            finalInit = {

                ...init,

                headers: {

                    ...existingHeaders,

                    Authorization: `Bearer ${token}`

                }

            };

        }

    }

    const response = await originalFetch(input, finalInit);

    if (response.status === 401 && isOwnApiRequest(input)) {

        // Session expired/invalid - don't let the app keep running in
        // a half-authenticated state. Skip this for the login call
        // itself (a wrong-password login returns status:false with a
        // 200, not a 401, so this never fires on a normal failed login).
        const wasLoggedIn = !!getToken();

        if (wasLoggedIn) {

            // Only clears auth-related keys - preserves device
            // preferences like Theme Settings' saved color.
            clearAuthStorage();

            window.location.href = "/";

        }

    }

    return response;

};
